/* eslint-disable complexity */
/*
 * ParticipantListBodyContainer.jsx 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */

/**
 * Container für die sichtbaren Teilnehmer in einer Liste. Fragt die Daten vom GraphQL-Interface ab und wendet eine Sortierung an
 */
import React from 'react';
import {connect} from 'react-redux';
import {compose, graphql} from 'react-apollo';
import ParticipantListBody from '../../components/participants/ParticipantListBody';
import {SORT_BY_DEADLINE, SORT_BY_NAME, SORT_BY_STEP} from '../../actions/types';
import {refreshLogin, selectParticipant, updateParticipantList} from '../../actions/actions';
import {sortByDeadline, sortByGoals, sortByLastname, sortByStep} from '../../utils';
import getParticipantsQuery from '../../queries/getParticipants.graphql';


/**
 * Query zum Beschaffen der Teilnehmerdaten. Diese enthalten NICHT die Zieldaten. Diese Daten werden asynchron nachgeladen und nachträglich zu den Teilnehmerdaten im Redux-Store
 * hinzugefügt.
 */
const withParticipants = graphql(getParticipantsQuery, {
    options: () => ({
        fetchPolicy: 'cache-and-network',
        pollInterval: 60000
    }),
    props: ({ownProps, data}) => {
        if (data.loading || !data.alleTeilnehmer) {
            return {
                loading: true
            };
        }

        if (data.error) {
            return {
                hasErrors: true
            };
        }

        // Wir wollen hier nicht auf das von Apollo/React erzeugte Objekt arbeiten.
        // Zudem bietet es sich an die Zielliste frühzeitig zu "initialisieren". Dies macht die nachfolgende Behandlung einfacher.
        const participantList = data.alleTeilnehmer.map(teilnehmerData => {
            const teilnehmer = Object.assign({}, teilnehmerData);
            teilnehmer.ziele = [];
            return teilnehmer;
        });

        return {
            ...ownProps,
            refetchParticipants: data.refetch,
            updateParticipantList,
            participantList
        };
    }
});

/**
 * Hilfs-Komponente, die lediglich die Teilnehmerdaten des GraphQL-Queries entgegen nimmt und an Redux weiterreicht.
 *
 * Wir müssen hier das Beschaffen der TN-Daten über GraphQL und das Ablegen im Redux-Store von der Prüfung der State-Änderungen an der Liste aufteilen, um über Redux keinen Zyklus
 * zu erhalten.
 */
class ParticipantListQuery extends React.Component {

    componentWillReceiveProps(nextProps) {
        // Wir wollen die Teilnehmerliste im Redux-Store nicht außerhalb des React-Lifecycle von Komponenten schreiben.
        if (nextProps.participantList) {
            this.props.updateParticipantList(nextProps.participantList);
        }
    }

    render() {
        return (
            <SortedParticipantListWrapper refetchParticipants={this.props.refetchParticipants} />
        );
    }
}

export default compose(connect(null, {updateParticipantList}), withParticipants)(ParticipantListQuery);



class SortedParticipantList extends React.Component {

    /**
     * Callback-Methode, die von den Sub-Komponenten aufgerufen werden soll, wenn das Nachladen von Zieldaten zu einem Teilnehmer erfolgreich abgeschlossen wurde.
     *
     * @param {Object} data Teilnehmerdaten inkl. der Zieldaten zu einem Teilnehmer.
     */
    onGoalDataLoaded(data) {
        const teilnehmerList = this.props.participantList || [];

        const teilnehmer = teilnehmerList.find(t => t.id === data.id);
        if (teilnehmer) {
            teilnehmer.ziele = data.ziele;
        }

        this.props.updateParticipantList(teilnehmerList);
    }

    render() {
        const { sort, participant } = this.props;
        let teilnehmerList = this.props.participantList || [];

        // Änderungen an den Teilnehmern bzw. Ziel-Daten erfordert leider ein erneutes Sortieren der TeilnehmerListe gemäß der vom Benutzer gewünschten Sortierung.
        if (teilnehmerList.length > 0) {
            if (sort.by === SORT_BY_NAME) {
                teilnehmerList = teilnehmerList.sort(sortByLastname);

            } else if (sort.by === SORT_BY_DEADLINE) {
                teilnehmerList = teilnehmerList.sort(sortByDeadline);

            } else if (sort.by === SORT_BY_STEP) {
                teilnehmerList = teilnehmerList.sort(sortByStep);

            } else {
                teilnehmerList = teilnehmerList.sort(sortByGoals);
            }
        }

        const refetchParticipants = () => {
            // Über 'refreshLogin' beziehen wir ein neues JW-Token mit aktuellen TeilnehmerIds (um es im GraphQL-Query in 'refetchParticipants' mitzugeben).
            // Dies ist notwendig, damit bei einem Gruppenwechsel, beim Entfernen oder Hinzufügen von Teilnehmern die Ansicht korrekt ist.
            this.props.refreshLogin().then(() => {
                this.props.refetchParticipants();
            });
        };

        return (
            <ParticipantListBody participants={teilnehmerList} selectedParticipant={participant.selected} selectParticipant={this.props.selectParticipant}
                onGoalDataLoaded={this.onGoalDataLoaded.bind(this)} refetchParticipants={refetchParticipants}/>
        );
    }
}


const mapDispatchToProps = {
    selectParticipant,
    refreshLogin,
    updateParticipantList
};

const mapStateToProps = ({sort, participant, participantList}) => ({sort, participant, participantList});

const SortedParticipantListWrapper = connect(mapStateToProps, mapDispatchToProps)(SortedParticipantList);



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/participants/ParticipantListBodyContainer.js